import { get } from "lodash";

import { TIME_TO_STALE } from "../../../constants/api.js";
import { AUTHENTICATION } from "../authentication/authenticationConstants.js";
import { WATCHERS } from "../../actions/actionConstants.js";

export const INITIAL = {
  isFetching: false,
  isErrored: false,
  isSuccess: false,
  isStale: false,
  lastCreated: null,
  timeReceived: 0,
  data: {}
};

export function singleEntityReducer(actionEntity) {
  if (!actionEntity) return null;

  return function (state = INITIAL, action = {}) {
    if (!action.type) return state;

    const isSuccess = get(action, "payload.success", true);

    switch (action.type) {
      case actionEntity.CHECK_STALE:
        const isStale = Date.now() - state.timeReceived > TIME_TO_STALE;
        return {
          ...state,
          isStale
        };

      case actionEntity.PUSHER_UPDATE:
        const atId = get(action, `data.@id`, null);
        const currentData = state["@id"] === atId;

        if (!currentData) return state;

        return {
          ...state,
          data: {
            ...state.data,
            ...action.data
          }
        };

      case actionEntity.RESET:
        return INITIAL;

      case actionEntity.GET:
      case actionEntity.POST:
      case actionEntity.PUT:
      case actionEntity.REQUEST:
      case actionEntity.DELETE:
        return {
          ...state,
          isFetching: true,
          isErrored: false,
          isSuccess: false
        };

      case actionEntity.RECEIVE:
        let data = action.payload;

        const timeReceived = Date.now();

        return {
          ...state,
          isFetching: false,
          isStale: false,
          timeReceived,
          lastCreated: null,
          data
        };

      case actionEntity.FAILURE:
        return {
          ...state,
          isFetching: false,
          isErrored: true
        };

      case actionEntity.DELETE_COMPLETE:
        return {
          ...state,
          isSuccess,
          isFetching: false
        };

      case actionEntity.POST_COMPLETE:
        const lastCreated = get(action, "payload.@id", null);

        return {
          ...state,
          isSuccess,
          isFetching: false,
          lastCreated
        };

      case actionEntity.GET_COMPLETE:
      case actionEntity.PUT_COMPLETE:
        return {
          ...state,
          isSuccess,
          isFetching: false
        };

      case WATCHERS.RESET:
        return {
          ...state,
          isFetching: false
        };

      case AUTHENTICATION.LOGOUT.RECEIVE:
      case AUTHENTICATION.LOGIN.FAILURE:
        return INITIAL;

      default:
        return state;
    }
  };
}

export default {};
